import Swal from 'sweetalert2'
const OPTION = {
  customClass: {
    confirmButton: `btn ${gon.is_plan_akapon ? 'btn-danger' :'btn-primary'} mx-1 font-size-button-popup`,
    cancelButton: 'btn btn-secondary mx-1 font-size-button-popup',
    popup: 'new_alert_popup',
  },
  buttonsStyling: false
}
const swalWithBootstrapButtons = Swal.mixin(OPTION)

export default class Popup {
  alert(content, icon = '', title = '', options = {}) {
    // 新トースト表示（全ページ統一）
    var toast = document.getElementById('tm-mode-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'tm-mode-toast';
      toast.style.cssText = [
        'position:fixed',
        'top:50%',
        'left:50%',
        'transform:translate(-50%,-50%)',
        'background:rgba(0,0,0,0.75)',
        'color:#fff',
        'padding:10px 22px',
        'border-radius:8px',
        'font-size:14px',
        'pointer-events:none',
        'z-index:2147483640',
        'opacity:0',
        'transition:opacity 0.3s'
      ].join(';');
      document.body.appendChild(toast);
    }
    if (options && options.big) {
      toast.style.padding = '20px 40px';
      toast.style.fontSize = '17px';
    } else {
      toast.style.padding = '10px 22px';
      toast.style.fontSize = '14px';
    }
    toast.innerHTML = title || content;
    toast.style.opacity = '1';
    if (typeof window._tmOnToast === 'function') window._tmOnToast(toast.innerHTML);
    clearTimeout(window._popupAlertToastTimer);
    window._popupAlertToastTimer = setTimeout(function() {
      toast.style.opacity = '0';
    }, (options && options.duration) ? options.duration : 2000);
    // 外部クリックで即閉じる（秒数は変えない・追加のみ）
    setTimeout(function() {
      var __tmOnDocClickAlert = function() {
        toast.style.opacity = '0';
        clearTimeout(window._popupAlertToastTimer);
        document.removeEventListener('click', __tmOnDocClickAlert, true);
      };
      document.addEventListener('click', __tmOnDocClickAlert, true);
    }, 0);
  }

  notice(text, status = 'success') {
    swalWithBootstrapButtons.fire({
      text,
      icon: status
    })
  }

  popupNotify(text) {
    Swal.fire({
      position: 'top-end',
      title: `<span style="color: black; font-size: 20px">${text}</span>`,
      showConfirmButton: false,
      timer: 2000,
    })
  }

  confirm(content, options = {}) {
    const successCallback = options.success || (() => {});
    const cancelCallback  = options.cancel  || (() => {});
    const confirmText     = options.confirmText || 'OK';
    const cancelText      = options.cancelText  || 'キャンセル';
    const hideCancel      = options.cancelBtn === 'false' || options.cancelBtn === false;

    // 既存のtm-confirmがあれば削除
    const existing = document.getElementById('tm-confirm-overlay');
    if (existing) existing.remove();

    const overlay = document.createElement('div');
    overlay.id = 'tm-confirm-overlay';
    overlay.style.cssText = [
      'position:fixed', 'inset:0', 'z-index:2147483647',
      'display:flex', 'align-items:center', 'justify-content:center',
      'background:rgba(0,0,0,0.55)'
    ].join(';');

    // <br> タグをそのまま表示するためinnerHTMLを使用
    overlay.innerHTML = `
      <div style="
        background:#1a1a1a;
        color:#fff;
        border-radius:16px;
        box-shadow:0 20px 48px rgba(0,0,0,.6);
        padding:32px 28px 24px;
        max-width:${options.maxWidth || '500px'};
        width:calc(100vw - 48px);
        text-align:center;
        font-family:sans-serif;
      ">
        <p style="font-size:15px;line-height:1.7;margin:0 0 24px;font-weight:500;color:#fff;">
          ${content}
        </p>
        <div style="display:flex;gap:12px;justify-content:center;">
          <button id="tm-confirm-ok" style="
            flex:1;max-width:120px;margin:0 6px;
            padding:10px 0;border:none;border-radius:10px;
            background:#e60c11;color:#fff;
            font-size:14px;font-weight:700;cursor:pointer;
            box-shadow:0 4px 12px rgba(230,12,17,.4);
          ">${confirmText}</button>
          ${hideCancel ? '' : `<button id="tm-confirm-cancel" style="
            flex:1;max-width:120px;margin:0 6px;
            padding:10px 0;border:none;border-radius:10px;
            background:rgba(255,255,255,.12);color:#fff;
            font-size:14px;font-weight:700;cursor:pointer;
          ">${cancelText}</button>`}
        </div>
      </div>
    `;

    document.body.appendChild(overlay);

    const close = () => overlay.remove();

    overlay.querySelector('#tm-confirm-ok').addEventListener('click', (e) => {
      e.stopPropagation();
      successCallback();
      close();
    });
    const cancelBtnEl = overlay.querySelector('#tm-confirm-cancel');
    if (cancelBtnEl) {
      cancelBtnEl.addEventListener('click', (e) => {
        e.stopPropagation();
        cancelCallback();
        close();
      });
    }
    // 外部クリックでキャンセル（キャンセル非表示時は閉じない）
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay && (!hideCancel || options.closeOnOverlay)) { close(); cancelCallback(); }
    });
  }

  limitedModal(content, options = {}) {
    const onRevoke = options.onRevoke || (() => {});
    const onPromote = options.onPromote || (() => {});
    const isOwner = options.isOwner !== false;
    const existing = document.getElementById('tm-limited-overlay');
    if (existing) existing.remove();
    const overlay = document.createElement('div');
    overlay.id = 'tm-limited-overlay';
    overlay.style.cssText = ['position:fixed','inset:0','z-index:2147483647','display:flex','align-items:center','justify-content:center','background:rgba(0,0,0,0.55)'].join(';');
    overlay.innerHTML = `
      <div style="position:relative;background:#1a1a1a;color:#fff;border-radius:16px;box-shadow:0 20px 48px rgba(0,0,0,.6);padding:32px 28px 24px;max-width:560px;width:calc(100vw - 48px);max-height:80vh;overflow-y:auto;text-align:center;font-family:sans-serif;">
        <span id="tm-limited-close" style="position:absolute;top:14px;right:18px;font-size:22px;line-height:1;cursor:pointer;color:#bbb;">&times;</span>
        <div style="font-size:15px;line-height:1.7;margin:4px 0 24px;font-weight:500;color:#fff;text-align:left;">${content}</div>
        <div style="display:flex;gap:12px;justify-content:center;">
          <button id="tm-limited-revoke" style="flex:1;max-width:150px;padding:10px 0;border:none;border-radius:10px;background:#e60c11;color:#fff;font-size:14px;font-weight:700;cursor:pointer;box-shadow:0 4px 12px rgba(230,12,17,.4);">解除する</button>
          <button id="tm-limited-promote" style="flex:1;max-width:170px;padding:10px 0;border:none;border-radius:10px;background:rgba(255,255,255,.12);color:#fff;font-size:14px;font-weight:700;cursor:pointer;">${isOwner ? '通常招待に切替える' : 'キャンセル'}</button>
        </div>
        <div style="margin-top:18px;">${isOwner ? (options.footnote || '') : (options.footnoteLimitedOnly || '')}</div>
      </div>`;
    document.body.appendChild(overlay);
    const close = (e) => { if (e) { e.preventDefault(); e.stopPropagation(); } overlay.remove(); };
    overlay.querySelector('#tm-limited-close').addEventListener('click', (e) => { close(e); });
    overlay.querySelector('#tm-limited-revoke').addEventListener('click', (e) => { e.stopPropagation(); onRevoke(); close(e); });
    overlay.querySelector('#tm-limited-promote').addEventListener('click', (e) => { e.stopPropagation(); if (isOwner) onPromote(); close(e); });
    overlay.addEventListener('click', (e) => { e.stopPropagation(); if (e.target === overlay) close(e); });
  }

  customConfirm(idTemplate, successFunction, falseFunction, cancelFunction) {
    Swal.fire({
      template: idTemplate
    }).then((result) => {
      if (result.isConfirmed) {
        if (typeof successFunction === 'function') successFunction();
      } else if (result.isDenied) {
        if (typeof falseFunction === 'function') falseFunction();
      } else if (result.dismiss) {
        if (typeof cancelFunction === 'function') cancelFunction();
      }
    })
  }

  async popupConfirmCheckbox(text, options = {}) {
    options.inputPlaceholder ||= ''
    options.confirmButtonText ||= 'OK'
    options.confirmButtonColor || '#004a8f'
    options.success ||= null
    options.cancel ||= null
    const { value: accept } = await Swal.fire({
      title: `<h5 class="no-bottom-margin">${text}</h5>`,
      input: 'checkbox',
      inputValue: 0,
      inputPlaceholder: options.inputPlaceholder,
      confirmButtonText: options.confirmButtonText,
    })
    if (options.confirmButtonColor) {
      $('.swal2-confirm').css('background-color', options.confirmButtonColor)
                         .css('border-color', options.confirmButtonColor)
    }
    if (accept) {
      if (typeof options.success === 'function') options.success()
    } else {
      if (typeof options.cancel === 'function') options.cancel()
    }
  }

  close() {
    Swal.close();
  }

  contentModal(content, options = {}) {
    const existing = document.getElementById('tm-content-overlay');
    if (existing) existing.remove();
    const title = options.title || '';
    const overlay = document.createElement('div');
    overlay.id = 'tm-content-overlay';
    overlay.style.cssText = ['position:fixed','inset:0','z-index:2147483647','display:flex','align-items:center','justify-content:center','background:rgba(0,0,0,0.55)'].join(';');
    overlay.innerHTML = `
      <div style="position:relative;background:#fff;color:#333;border-radius:12px;box-shadow:0 20px 48px rgba(0,0,0,.4);max-width:${options.maxWidth || '760px'};width:calc(100vw - 48px);font-family:sans-serif;overflow:hidden;">
        <div style="display:flex;align-items:center;justify-content:center;position:relative;padding:14px 20px;border-bottom:1px solid #e5e7eb;">
          <span style="color:#202f55;font-weight:700;font-size:16px;">${title}</span>
          <span id="tm-content-close" style="position:absolute;top:12px;right:18px;font-size:22px;line-height:1;cursor:pointer;color:#999;">&times;</span>
        </div>
        <div style="padding:20px 20px 8px;text-align:left;">${content}</div>
        <div style="display:flex;justify-content:center;padding:8px 20px 20px;">
          <button id="tm-content-ok" style="min-width:120px;padding:10px 20px;border:none;border-radius:8px;background:#202f55;color:#fff;font-size:14px;font-weight:700;cursor:pointer;">閉じる</button>
        </div>
      </div>`;
    document.body.appendChild(overlay);
    const close = (e) => { if (e) { e.preventDefault(); e.stopPropagation(); } overlay.remove(); };
    overlay.querySelector('#tm-content-close').addEventListener('click', close);
    overlay.querySelector('#tm-content-ok').addEventListener('click', close);
    overlay.addEventListener('click', (e) => { if (e.target === overlay) close(e); });
  }
}


// ===== 更新中オーバーレイ（確定押下〜サーバー応答までの「無反応に見える数秒」対策） =====
// 画面全体を薄グレーにして「更新中…」を表示する。二重押し防止も兼ねる。
(function () {
  var TIMEOUT_MS = 60000; // 万一応答が来ない時の自動解除
  var timer = null;

  function ensureStyle() {
    if (document.getElementById('tm-loading-style')) return;
    var st = document.createElement('style');
    st.id = 'tm-loading-style';
    st.textContent = '@keyframes tmSpin{to{transform:rotate(360deg)}}';
    document.head.appendChild(st);
  }

  window.tmShowLoading = function (message) {
    try {
      if (document.getElementById('tm-loading-overlay')) return;
      ensureStyle();
      var ov = document.createElement('div');
      ov.id = 'tm-loading-overlay';
      ov.style.cssText = [
        'position:fixed', 'inset:0', 'z-index:2147483646',
        'display:flex', 'align-items:center', 'justify-content:center',
        'background:rgba(0,0,0,0.35)', 'cursor:wait'
      ].join(';');
      ov.innerHTML =
        '<div style="background:#fff;border-radius:8px;padding:22px 34px;display:flex;align-items:center;gap:14px;box-shadow:0 4px 16px rgba(0,0,0,0.25);">' +
        '<span style="width:26px;height:26px;border:3px solid #e2e2e2;border-top-color:#1d2b50;border-radius:50%;display:inline-block;animation:tmSpin 0.8s linear infinite;"></span>' +
        '<span style="font-size:15px;color:#1d2b50;font-weight:700;">' + (message || '更新中…') + '</span>' +
        '</div>';
      // クリックを全部受け止めて二重押しを防ぐ
      ov.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); }, true);
      document.body.appendChild(ov);
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () { window.tmHideLoading(); }, TIMEOUT_MS);
    } catch (e) { console.error('tmShowLoading error', e); }
  };

  window.tmHideLoading = function () {
    try {
      if (timer) { clearTimeout(timer); timer = null; }
      var ov = document.getElementById('tm-loading-overlay');
      if (ov) ov.remove();
    } catch (e) { console.error('tmHideLoading error', e); }
  };

  // 「確定する」ボタン。押した直後に数秒の重い処理が走るため、
  // 先にグレー画面を1フレーム描いてから、本来の処理を進める
  var CONFIRM_BTN = '#submit_update_project_permissions, #submit-update-project-permissions, .submit-invite-member-wrapper button[type="submit"]';
  var FORM_SEL = '#popup_update_project_permission, #popupInviteMember form';

  function onCaptureClick(e) {
    try {
      var t = e.target;
      if (!t || !t.closest) return;
      var btn = t.closest(CONFIRM_BTN);
      if (!btn) return;
      if (btn.getAttribute('data-tm-loading-go') === '1') {
        btn.removeAttribute('data-tm-loading-go');
        return; // 2回目のクリック＝本来の処理をそのまま通す
      }
      e.preventDefault();
      e.stopPropagation();
      window.tmShowLoading('更新中…');
      // 描画を1回終えてから重い処理へ進む(これをしないとグレーが見えない)
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          setTimeout(function () {
            btn.setAttribute('data-tm-loading-go', '1');
            btn.click();
          }, 0);
        });
      });
    } catch (err) { console.error('tm loading click error', err); }
  }

  function bind() {
    if (!window.jQuery) return;
    var $ = window.jQuery;
    if ($(document).data('tm-loading-bound')) return;
    $(document).data('tm-loading-bound', true);

    document.addEventListener('click', onCaptureClick, true);
    $(document).on('ajax:complete ajax:error ajax:success', FORM_SEL, function () { window.tmHideLoading(); });
    $(document).on('hidden.bs.modal', function () { setTimeout(function () { window.tmHideLoading(); }, 300); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  document.addEventListener('turbolinks:load', bind);
})();
